import React from 'react';
import {
  Menu,
  Icon,
  Dropdown
} from 'semantic-ui-react';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';

import * as routes from '../../shared/routes';

import { useDispatch } from 'react-redux'

import { clearError} from '../signing/ovscSlice'
import { clearError as clearAuthenticodeError } from '../authenticode/authenticodeSlice';
import { useQuery} from '../../shared/useQuery';
import { Media} from './Media'
const MobileContainer:React.FC = ( props:any ) => {
  const { t, i18n } = useTranslation();

  const dispatch = useDispatch();

 
  const language = i18n.language.substr(0,2);
  
  const languageString = t("menue.language") + ": " + t("menue." +language);

  const userLanguage = useQuery().get("lang");

  const dm = userLanguage === null ? (
    <Dropdown.Item>
      <i className={"flag "+(language === 'en' ? 'us': language)}></i>
      <Icon name='dropdown' />
      <span className='text'>{languageString}</span>
      <Dropdown.Menu>
        <Dropdown.Item disabled={language==="de"} onClick={()=>{i18n.changeLanguage("de")}}><i className="flag de"></i>{t('menue.de')}</Dropdown.Item>
        <Dropdown.Item disabled={language==="en"} onClick={()=>{i18n.changeLanguage("en")}}><i className="flag us"></i>{t('menue.en')}</Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown.Item>
  ) :null;
 
  return (
    <Media at='mobile'>
      <Menu>
        <Dropdown item icon='sidebar' simple>
            <Dropdown.Menu>
              <Dropdown.Item
                name="home"
                as={NavLink}
                to={routes.HOME}
                onClick={() => { dispatch(clearError()); }}
              >
                <Icon name="home" inverted />
                {t('menue.analyze')}
              </Dropdown.Item>
              <Dropdown.Item name="sign" as={NavLink} to={routes.SIGN} onClick={() => {  dispatch(clearError()); }}><Icon name="cog" inverted /> {t('menue.sign')}</Dropdown.Item>
              <Dropdown.Item name="authenticode" as={NavLink} to={routes.AUTHENTICODE} onClick={() => dispatch(clearAuthenticodeError())}><Icon name="file alternate" inverted />{t('menue.authenticode')}</Dropdown.Item>
              {dm}
              </Dropdown.Menu>
          </Dropdown>
        </Menu>
        {props.children}
    </Media>
  );
}
export default MobileContainer
